import React from 'react';
import { Link } from 'react-router-dom';
import { TrendingUp, ShieldCheck } from 'lucide-react';

/**
 * UnverifiedExplainer — what /scan and /attribution show a club ADMIN while
 * the club is unverified (W-2 follow-up). Before this, the pages rendered an
 * empty shell over a 403. Same revenue case as the Club Sponsors tab, one
 * link to the form (or a "with us" line once submitted).
 */
const UnverifiedExplainer = ({ clubSlug, club, what }) => (
  <div className="card" style={{ maxWidth: 620, margin: '20px auto', padding: '22px 24px' }}>
    <h3 style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
      <TrendingUp size={18} /> {what} switches on once you're verified
    </h3>
    <p style={{ fontSize: 14, lineHeight: 1.6, color: 'var(--text-secondary)' }}>
      <strong>Marakin brings sponsor money into verified clubs.</strong> Sponsors, member offers, the
      scan-at-the-till QR flow and the attribution numbers that keep sponsors renewing all unlock the
      moment Marakin verifies {club?.name || 'your club'}.
    </p>
    {club?.verification_submitted_at ? (
      <p style={{ fontSize: 14, lineHeight: 1.6, color: 'var(--marakin-accent, #1E4A35)', display: 'flex', gap: 6, alignItems: 'center' }}>
        <ShieldCheck size={15} /> Your details are with us — we'll be in touch shortly, normally within a day or two.
      </p>
    ) : (
      <Link className="btn btn-primary" to={`/${clubSlug}/admin?tab=sponsors`}>Complete your verification details</Link>
    )}
  </div>
);

export default UnverifiedExplainer;
